export const isTruncated = e => {
    const tempNode = e.cloneNode(true)

    tempNode.style.position = 'fixed'
    tempNode.style.overflow = 'visible'
    tempNode.style.whiteSpace = 'nowrap'
    tempNode.style.visibility = 'hidden'

    e.parentElement.appendChild(tempNode)

    try {
        const fullWidth = tempNode.getBoundingClientRect().width
        const displayWidth = e.getBoundingClientRect().width

        return fullWidth > displayWidth
    } finally {
        tempNode.parentElement.removeChild(tempNode)
    }
}